import { connect } from "react-redux";
import selectors from "ui/molecule/errorPage/selectors";
import ErrorPageUI from "ui/molecule/errorPage/ErrorPageUI";

// alebo takto temu mame v props export default withStyles(customStyles, { withTheme: true })(AddBabySitterUI);
export default connect(selectors)(ErrorPageUI);
